// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1___b01d8666b9c062d1588","cls2":"NewsHeader-cls2___58c7d6404c9aacf9e85 NewsHeader-cls1___b01d8666b9c062d1588"};